import { toastError } from "components/toast/billing_toast";
import { KitHttp, UpdateAndPostKitModel } from "gateways/repo/kit_http_cliente";
import { ModeloHttp } from "gateways/repo/modelo_http_client";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { resetKitNew, setKitModelos, setKitView, setKitLoading } from "store/kit/view_kit_slice";
import { useAppDispatch } from "store/store";

const useViewKit = () => {
  const http = new KitHttp();
  const httpModelo = new ModeloHttp();

  const navigate = useNavigate();
  const params = useParams();
  const dispatch = useAppDispatch();

  const [isErrorKit, setErrorKit] = useState<boolean>(false);

  const getViewKit = async () => {
    setErrorKit(false);
    dispatch(setKitLoading(true));
    try {
      const data = await http.getKitById(params.id!);
      const options = await httpModelo.getModelosOptions();
      dispatch(setKitView(data));
      dispatch(setKitModelos(options.Lista));
    } catch (e) {
      setErrorKit(true);
      console.log(e);
    } finally {
      dispatch(setKitLoading(false));
    }
  };
  const updateKit = async (data: UpdateAndPostKitModel) => {
    dispatch(setKitLoading(true));

    try {
      await http.updateKit(data);
      navigate("/cadastro/kit");
      dispatch(resetKitNew());
    } catch (error) {
      toastError({
        title: "Algo deu errado!",
        message: "Erro ao editar, por favor tente novamente.",
      });
    } finally {
      dispatch(setKitLoading(false));
    }
  };

  return {
    isErrorKit,
    getViewKit,
    updateKit,
  };
};
export default useViewKit;
